import * as z from 'zod';
export const CorrectGuessesRowSchema = z.object({
    normalizedName: z.string(),
});
export const DrawRowSchema = z.object({
    sub: z.string(),
    userId: z.uuidv7(),
    drawId: z.uuidv7(),
    ordering: z.int(),
    status: z.enum(['winner', 'candidate']),
    selectedAt: z.int().nullable(),
});
export const GuessDistributionSchema = z.object({
    correctGuessDistribution: z.record(z.string(), z.number().min(0).max(1).multipleOf(0.001)),
});
//# sourceMappingURL=result.js.map